import { render, staticRenderFns } from "./conference.vue?vue&type=template&id=3ea16bb4&scoped=true&"
import script from "./conference.vue?vue&type=script&lang=js&"
export * from "./conference.vue?vue&type=script&lang=js&"
import style0 from "./conference.vue?vue&type=style&index=0&id=3ea16bb4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea16bb4",
  null
  
)

export default component.exports